 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import TOC from '@/components/toc'
 import A_CHAPTER101ENMITYOFFACESMACKING from '@/components/0_chapter101enmityoffacesmacking'
 import A_CHAPTER102SIBLINGFIGHTING from '@/components/1_chapter102siblingfighting'
 import A_CHAPTER103INEQUALITYOFROAD from '@/components/2_chapter103inequalityofroad'
 import A_CHAPTER104LIGHTNING from '@/components/3_chapter104lightning'
 import A_CHAPTER105LEIXIU from '@/components/4_chapter105leixiu'
 import A_CHAPTER106ENDOFAUDITION from '@/components/5_chapter106endofaudition'
 import A_CHAPTER107SNOWFLAKE from '@/components/6_chapter107snowflake'
 import A_CHAPTER108THEBATTLEOFTHEDEMONS from '@/components/7_chapter108thebattleofthedemons'
 import A_CHAPTER109QILINDEMONSOLDIERS from '@/components/8_chapter109qilindemonsoldiers'
 import A_CHAPTER110WINNING from '@/components/9_chapter110winning'
 import A0_CHAPTER111RESENTMENT from '@/components/10_chapter111resentment'
 import A1_CHAPTER112GOLDENMARIONETTE from '@/components/11_chapter112goldenmarionette'
 import A2_CHAPTER113DEMONARMYATTACK from '@/components/12_chapter113demonarmyattack'
 import A3_CHAPTER114DEMONICHORDE from '@/components/13_chapter114demonichorde'
 import A4_CHAPTER115FIGHTINGDEMONSOLDIERSHEADON from '@/components/14_chapter115fightingdemonsoldiersheadon'
 import A5_CHAPTER116ENDOFPRELIMINARYCOMPETITION from '@/components/15_chapter116endofpreliminarycompetition'
 import A6_CHAPTER117FRUCTUSARTEMISIAE from '@/components/16_chapter117fructusartemisiae'
 import A7_CHAPTER118ARROGANTLACKEYS from '@/components/17_chapter118arrogantlackeys'
 import A8_CHAPTER119STRENGTH from '@/components/18_chapter119strength'
 import A9_CHAPTER120THEDIFFICULTIESOFFLATTEN from '@/components/19_chapter120thedifficultiesofflatten'
 import A0_CHAPTER121SUNDAWEI from '@/components/20_chapter121sundawei'
 import A1_CHAPTER122SUSPECT from '@/components/21_chapter122suspect'
 import A2_CHAPTER123DINNER from '@/components/22_chapter123dinner'
 import A3_CHAPTER124INNERCOURTMAN from '@/components/23_chapter124innercourtman'
 import A4_CHAPTER125DEFEAT from '@/components/24_chapter125defeat'
 import A5_CHAPTER126HUMANSACRIFICECEREMONY from '@/components/25_chapter126humansacrificeceremony'
 import A6_CHAPTER127DECLINE from '@/components/26_chapter127decline'
 import A7_CHAPTER128ONTHEEVEOFTHESACRIFICECEREMONY from '@/components/27_chapter128ontheeveofthesacrificeceremony'
 import A8_CHAPTER129CEREMONYOFTHESACRIFICEOFTHEHUMANRACE from '@/components/28_chapter129ceremonyofthesacrificeofthehumanrace'
 import A9_CHAPTER130ATTHECEREMONYOFHUMANSACRIFICE from '@/components/29_chapter130attheceremonyofhumansacrifice'
 import A0_CHAPTER131FANTASYPLAINS from '@/components/30_chapter131fantasyplains'
 import A1_CHAPTER132DEPARTURE from '@/components/31_chapter132departure'
 import A2_CHAPTER133DEPARTUREINPROGRESS from '@/components/32_chapter133departureinprogress'
 import A3_CHAPTER134DEPARTURE from '@/components/33_chapter134departure'
 import A4_CHAPTER135GAMBLER from '@/components/34_chapter135gambler'
 import A5_CHAPTER136LEAVE from '@/components/35_chapter136leave'
 import A6_CHAPTER137MENSTEARS from '@/components/36_chapter137menstears'
 import A7_CHAPTER138COOPERATION from '@/components/37_chapter138cooperation'
 import A8_CHAPTER139TASK from '@/components/38_chapter139task'
 import A9_CHAPTER140ESCORTCARAVAN from '@/components/39_chapter140escortcaravan'
 import A0_CHAPTER141AVISITTOTHECITYOFTHEWICKED from '@/components/40_chapter141avisittothecityofthewicked'
 import A1_CHAPTER142AVISITTOTHECITYOFTHEWICKED from '@/components/41_chapter142avisittothecityofthewicked'
 import A2_CHAPTER143AVISITTOTHECITYOFTHEWICKED from '@/components/42_chapter143avisittothecityofthewicked'
 import A3_CHAPTER144AVISITTOTHECITYOFTHEWICKED from '@/components/43_chapter144avisittothecityofthewicked'
 import A4_CHAPTER145AVISITTOTHECITYOFTHEWICKED from '@/components/44_chapter145avisittothecityofthewicked'
 import A5_CHAPTER146AVISITTOTHECITYOFTHEWICKED from '@/components/45_chapter146avisittothecityofthewicked'
 import A6_CHAPTER147AVISITTOTHECITYOFTHEWICKED from '@/components/46_chapter147avisittothecityofthewicked'
 import A7_CHAPTER148AVISITTOTHECITYOFTHEWICKED from '@/components/47_chapter148avisittothecityofthewicked'
 import A8_CHAPTER149TOUROFTHEWICKED9 from '@/components/48_chapter149tourofthewicked9'
 import A9_CHAPTER150ACITYOFTHEWICKEDTEN from '@/components/49_chapter150acityofthewickedten'
 import A0_CHAPTER151AVISITTOTHECITYOFTHEWICKED from '@/components/50_chapter151avisittothecityofthewicked'
 import A1_CHAPTER152ACITYOFTHEWICKEDTWELVE from '@/components/51_chapter152acityofthewickedtwelve'
 import A2_CHAPTER153AVISITTOTHECITYOFTHEWICKED from '@/components/52_chapter153avisittothecityofthewicked'
 import A3_CHAPTER154AVISITTOTHECITYOFTHEWICKED from '@/components/53_chapter154avisittothecityofthewicked'
 import A4_CHAPTER155AVISITTOTHECITYOFTHEWICKED from '@/components/54_chapter155avisittothecityofthewicked'
 import A5_CHAPTER156AVISITTOTHECITYOFTHEWICKED from '@/components/55_chapter156avisittothecityofthewicked'
 import A6_CHAPTER157AVISITTOTHECITYOFTHEWICKED from '@/components/56_chapter157avisittothecityofthewicked'
 import A7_CHAPTER158GANGSTERONTHEROAD from '@/components/57_chapter158gangsterontheroad'
 import A8_CHAPTER159FORTUNETELLING from '@/components/58_chapter159fortunetelling'
 import A9_CHAPTER160TENTATIVEWINDANDRAIN from '@/components/59_chapter160tentativewindandrain'
 import A0_CHAPTER161HETEROMORPHISM from '@/components/60_chapter161heteromorphism'
 import A1_CHAPTER162BLOODCONTINENT from '@/components/61_chapter162bloodcontinent'
 import A2_CHAPTER163SEVENTHYOUNGMASTER from '@/components/62_chapter163seventhyoungmaster'
 import A3_CHAPTER164WINTHEHEARTSANDMINDSOFTHEPEOPLE from '@/components/63_chapter164wintheheartsandmindsofthepeople'
 import A4_CHAPTER165PLANNING from '@/components/64_chapter165planning'
 import A5_CHAPTER166UPLIFT from '@/components/65_chapter166uplift'
 import A6_CHAPTER167BUSINESSPLAN from '@/components/66_chapter167businessplan'
 import A7_CHAPTER168TASKCHANGE from '@/components/67_chapter168taskchange'
 import A8_CHAPTER169BREAKTHROUGHMIDFOUNDATIONESTABLISHMENT from '@/components/68_chapter169breakthroughmidfoundationestablishment'
 import A9_CHAPTER170MAJORREWARD from '@/components/69_chapter170majorreward'
 import A0_CHAPTER171STRIKE from '@/components/70_chapter171strike'
 import A1_CHAPTER172NEGOTIATION from '@/components/71_chapter172negotiation'
 import A2_CHAPTER173THESTRUGGLEBETWEENTHETHREEFACTIONS from '@/components/72_chapter173thestrugglebetweenthethreefactions'
 import A3_CHAPTER174RECONCILIATION from '@/components/73_chapter174reconciliation'
 import A4_CHAPTER175TRAVELLER from '@/components/74_chapter175traveller'
 import A5_CHAPTER176RECRUITMENT from '@/components/75_chapter176recruitment'
 import A6_CHAPTER177OPENSPRING from '@/components/76_chapter177openspring'
 import A7_CHAPTER178ACQUISITIONOFMYSTICALMATERIALS from '@/components/77_chapter178acquisitionofmysticalmaterials'
 import A8_CHAPTER179NEGOTIATION from '@/components/78_chapter179negotiation'
 import A9_CHAPTER180THEBLACKTIGERGANGSPLAN from '@/components/79_chapter180theblacktigergangsplan'
 import A0_CHAPTER181NORTHERNSUBURBINSECTNEST from '@/components/80_chapter181northernsuburbinsectnest'
 import A1_CHAPTER182ACCIDENT from '@/components/81_chapter182accident'
 import A2_CHAPTER183WORMNEST from '@/components/82_chapter183wormnest'
 import A3_CHAPTER184SEEKERMOUNTAIN from '@/components/83_chapter184seekermountain'
 import A4_CHAPTER185JADEDRAGONANCESTOR from '@/components/84_chapter185jadedragonancestor'
 import A5_CHAPTER186ESCAPEFROMDEATH from '@/components/85_chapter186escapefromdeath'
 import A6_CHAPTER187CLEANING from '@/components/86_chapter187cleaning'
 import A7_CHAPTER188CRYOLITEORE from '@/components/87_chapter188cryoliteore'
 import A8_CHAPTER189THEWRECKAGEOFASTARSHIP from '@/components/88_chapter189thewreckageofastarship'
 import A9_CHAPTER190SNOWRACE from '@/components/89_chapter190snowrace'
 import A0_CHAPTER191SILVERWOLFMOUNT from '@/components/90_chapter191silverwolfmount'
 import A1_CHAPTER192NEWSFROMTHESTONEMOUNTAIN from '@/components/91_chapter192newsfromthestonemountain'
 import A2_CHAPTER193HORNLESSALIEN from '@/components/92_chapter193hornlessalien'
 import A3_CHAPTER194REMINISCENCE from '@/components/93_chapter194reminiscence'
 import A4_CHAPTER195DIFFICULT from '@/components/94_chapter195difficult'
 import A5_CHAPTER196CHAOYANGCITY from '@/components/95_chapter196chaoyangcity'
 import A6_CHAPTER197ANGRYLIDENE from '@/components/96_chapter197angrylidene'
 import A7_CHAPTER198SUNSTAR from '@/components/97_chapter198sunstar'
 import A8_CHAPTER199DRINKSPITYOU from '@/components/98_chapter199drinkspityou'
 import A9_CHAPTER200CHALLENGE from '@/components/99_chapter200challenge'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/cover",
 			"name" : "cover",
 			"component" : COVER
 		},
 		{
 			"path" : "/toc",
 			"name" : "toc",
 			"component" : TOC
 		},
 		{
 			"path" : "/0_chapter101enmityoffacesmacking",
 			"name" : "0_chapter101enmityoffacesmacking",
 			"component" : A_CHAPTER101ENMITYOFFACESMACKING
 		},
 		{
 			"path" : "/1_chapter102siblingfighting",
 			"name" : "1_chapter102siblingfighting",
 			"component" : A_CHAPTER102SIBLINGFIGHTING
 		},
 		{
 			"path" : "/2_chapter103inequalityofroad",
 			"name" : "2_chapter103inequalityofroad",
 			"component" : A_CHAPTER103INEQUALITYOFROAD
 		},
 		{
 			"path" : "/3_chapter104lightning",
 			"name" : "3_chapter104lightning",
 			"component" : A_CHAPTER104LIGHTNING
 		},
 		{
 			"path" : "/4_chapter105leixiu",
 			"name" : "4_chapter105leixiu",
 			"component" : A_CHAPTER105LEIXIU
 		},
 		{
 			"path" : "/5_chapter106endofaudition",
 			"name" : "5_chapter106endofaudition",
 			"component" : A_CHAPTER106ENDOFAUDITION
 		},
 		{
 			"path" : "/6_chapter107snowflake",
 			"name" : "6_chapter107snowflake",
 			"component" : A_CHAPTER107SNOWFLAKE
 		},
 		{
 			"path" : "/7_chapter108thebattleofthedemons",
 			"name" : "7_chapter108thebattleofthedemons",
 			"component" : A_CHAPTER108THEBATTLEOFTHEDEMONS
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js